import { Modal, Input } from "antd"
import { useState } from 'react'
import { Visit } from '../../scheduleApi'
import { useUpdateVisitNotesMutation } from "../../scheduleQueries"

const { TextArea } = Input

type Props = {
  open: boolean
  onClose: () => void
  visit?: Visit | null
}

const ManageVisitNotes = ({ open, onClose, visit }: Props) => {
  const [note, setNote] = useState(visit?.internalNotes || '')
  const { mutate: updateVisitNotes } = useUpdateVisitNotesMutation()

  const handleSave = () => {
    updateVisitNotes({
      visitId: visit?.id || '',
      internalNotes: note || '',
      jobId: visit?.projectId || null,
    })
    onClose()
  }

  return (
    <Modal 
      open={open} 
      onCancel={onClose} 
      onOk={handleSave}
      title="Visit Note"
      okText="Save"
      cancelText="Cancel"
      width={500}
      styles={{
        body: { backgroundColor: '#fafbfc', padding: '16px' }
      }}
    >
      <div style={{ marginBottom: '16px' }}>
        <TextArea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter visit notes here..."
          rows={6}
          style={{
            backgroundColor: 'white',
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            fontSize: '14px',
            lineHeight: '1.5'
          }}
        />
      </div>
    </Modal>
  )
}

export default ManageVisitNotes